/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OasisAddendumViewModel } from './OasisAddendumViewModel'; 

export function getOasisAddendumOptions(id: string, onSuccess?: (result: OasisAddendumViewModel) => void) {
	return queryOptions({
		queryKey: ['oasis-addendum', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/oasis/queries/getoasisaddendum/' + id;
			const resp = await axios.get<OasisAddendumViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}